
import { reviewMixin } from './mixin/mixin.js';
import ReviewForm from './reviewForm.vue';
import { remarkOptions, materialGrading } from './review.js';
import _ from 'lodash';

export default {
  mixins: [reviewMixin],

  name: 'batchReviewMaterial.vue',

  components: {
    ReviewForm: ReviewForm
  },

  props: {
    materialIds: {
      type: String,
      required: true
    },

    tabName: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      required: true
    },

    visible: {
      type: Boolean,
      required: true
    },

    hideAuditDialog: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      form: {
        reason_ids: [],
        reason_text: '',
        ad_rule_text: '',
        review_opinion: 2
      },
      approveModel: {
        remark: [],
        material_grading: []
      },
      materialModel: {
        material_grading: []
      },
      materialConfig: {
        labelWidth: '120px'
      }
    };
  },


  computed: {
    approveSchema: function approveSchema() {
      return {
        type: 'object',
        properties: {
          remark: {
            title: '备注：',
            component: 'checkbox-group',
            field: {
              options: remarkOptions
            }
          },
          material_grading: {
            title: '素材分级：',
            component: 'select',
            field: {
              clearable: true,
              multiple: true,
              'collapse-tags': true,
              placeholder: '请选择素材分级',
              options: materialGrading
            }
          }
        }
      };
    },
    materialShema: function materialShema() {
      return {
        type: 'object',
        properties: {
          material_grading: {
            title: '素材分级：',
            component: 'select',
            rules: [{
              required: true,
              type: 'array',
              message: '请选择至少一个素材分级',
              trigger: 'change'
            }],
            field: {
              clearable: true,
              multiple: true,
              'collapse-tags': true,
              placeholder: '请选择素材分级',
              options: materialGrading
            }
          }
        }
      };
    }
  },

  watch: {
    visible: function visible() {
      this.$refs && this.$refs.form && this.$refs.form.resetFields();
      this.$refs && this.$refs.materialForm && this.$refs.materialForm.resetFields();
      this.$refs && this.$refs.approveForm && this.$refs.approveForm.resetFields();
    }
  },

  methods: {
    cookSubmitParams: function cookSubmitParams() {
      var reasonIds = _.sortBy(this.form.reason_ids, function (value) {
        return value;
      }).join(',');
      var utils = {
        reject: 2,
        approve: 3
      };
      var params = {
        status: utils[this.type]
      };

      var reason_text = {};
      // 是否有其他拒绝原因
      var hasOtherReason = this.form.reason_ids.some(function (item) {
        return item === 99;
      });
      if (hasOtherReason) {
        reason_text['99'] = this.form.reason_text;
      }
      // 是否有不合法广告要求
      var hasAdReason = this.form.reason_ids.some(function (item) {
        return item === 8;
      });
      if (hasAdReason) {
        reason_text['8'] = this.form.ad_rule_text;
      }
      if (hasOtherReason || hasAdReason) params.reason_text = reason_text;
      if (reasonIds) params.reason_ids = reasonIds;

      // 备注
      if (this.approveModel && this.approveModel.remark.length) {
        params.remark = this.approveModel.remark;
      }
      // 素材分级
      if (this.approveModel && this.approveModel.material_grading.length) {
        params.material_grading = this.approveModel.material_grading.join();
      }

      return params;
    }
  }
};